const KPISlugsForLegacyOrg = [
  'email_total_blacklisted',
  'email_total_blocked',
  'email_total_inbound',
  'email_total_inbound_vs_blacklisted',
  'email_total_inbound_vs_blocked',
  'email_total_inbound_vs_legitimate',
  'email_total_legitimate_vs_blacklisted',
  'email_total_legitimate_vs_blacklisted_vs_blocked',
  'email_total_legitimate_vs_blocked',
  'inbound_legit_vs_spams_detected_total_vs_total_viruses',
  'inbound_vs_spams_detected_total_vs_total_viruses',
  'journals_total',
  'outbounds_total',
  'spams_detected_total',
  'spams_detected_total_vs_whitelisted_spam',
  'spams_detected_vs_ham',
  'spams_flagged',
  'spams_hams_flagged',
  'spams_vs_total_inbound',
  'spams_whitelisted',
  'toolbox_item_downloaded',
  'toolbox_item_restore_failed',
  'viruses_detected_total',
  'viruses_detected_total_vs_total_inbound'
];

export default KPISlugsForLegacyOrg;
